import { get } from 'svelte/store';
import { getClerk } from './clerk.js';
import { datasource } from './stores.js';

// Thin fetch wrapper: attaches the Clerk session token and unwraps JSON / errors.
export async function api(path, options = {}) {
  const clerk = getClerk();
  const token = clerk && clerk.session ? await clerk.session.getToken() : null;
  const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  // Tell the server which Firestore source to read (prod vs staging).
  headers['X-Datasource'] = get(datasource);

  const res = await fetch(`/api${path}`, { ...options, headers });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || body.detail || `Request failed (${res.status})`);
  }
  return res.json();
}

// Download a file from the API (CSV exports). Same auth + datasource headers as
// api(); the response is saved via a temporary object URL because a plain <a>
// could not carry the Bearer token.
export async function apiDownload(path, filename) {
  const clerk = getClerk();
  const token = clerk && clerk.session ? await clerk.session.getToken() : null;
  const headers = { 'X-Datasource': get(datasource) };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(`/api${path}`, { headers });
  if (!res.ok) throw new Error((await res.text().catch(() => '')) || `Download failed (${res.status})`);
  const url = URL.createObjectURL(await res.blob());
  const a = document.createElement('a');
  a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
